import { store } from "@/store";
import { UserRest } from "@/services/rest/user.rest";
import User from "@/interfaces/User.interface";

export default class UserService{
    constructor(
        private _user = new UserRest()
    ){}

    getAllUsers(params: any){
        return this._user.getAllUsers(params).then((response) => {
            store.dispatch('users/setUsers', response)
        });
    }

    getUserById(id: any){
        return this._user.getUserById(id).then((response) => {
            store.dispatch('users/setUser', response)
        });
    }

    getUserInfo(){
        return this._user.getUserInfo().then((response) => {
            store.dispatch('users/setUserInfo', response)
        });
    }

    addUser(data: User): Promise<any>{
        return this._user.addUser(data)
    }

    updateUser(id: any, data: any): Promise<any>{
        return this._user.updateUser(id, data)
    }

    deleteUser(id: any): Promise<any>{
        return this._user.deleteUser(id)
    }

}